
/**
 * The string the user must type if a delete confirmation should be super safe.
 * 
 * @type { string }
 */
export const SUPER_SAFE_DELETE_CONFIRMATION_STRING = 'DELETE';
